import { gsap } from 'gsap'

interface VerifyEmailAnimationTargets {
  paper: SVGGElement | null
  checkmark: SVGGElement | null
}

/**
 * Mount animation for the verify-email illustration: the letter slides up
 * out of the envelope, then the checkmark badge pops in.
 */
export const playVerifyEmailIllustration = ({
  paper,
  checkmark,
}: VerifyEmailAnimationTargets) => {
  const tl = gsap.timeline()

  tl.set(paper, { y: 18 })
  tl.set(checkmark, { scale: 0, svgOrigin: '40.23 31.23' })

  tl.to(paper, { y: 0, duration: 0.6, ease: 'power2.out' })
  tl.to(checkmark, { scale: 1, duration: 0.4, ease: 'back.out(2.2)' }, '-=0.15')

  return tl
}
